<template>
  <div class="grid">
    <loading
      :active="isLoadingModel"
      :can-cancel="true"
      color="#274461"
      :is-full-page="fullPage"
    ></loading>
    <div class="col-12">
      <div class="card">
        <Breadcrumb :home="breadcrumbHome" :model="breadcrumbItems">
                <!--<template #item="{ item, props }">
                    <router-link v-if="item.to" v-slot="{ href, navigate }" :to="item.to" custom>
                        <a :href="href" v-bind="props.action" @click="navigate">
                            <span :class="[item.icon, 'text-color']" />
                            <span class="text-primary font-semibold">{{ item.label }}</span>
                        </a>
                    </router-link>
                </template>-->
            </Breadcrumb>
        <Toast />
        <Toolbar class="mb-4">
          <template v-slot:start>
            <div class="my-2">
              <span class="p-float-label">
                <InputText v-model="service_name"> </InputText>
                <label>Service Name</label>
                &nbsp;
                <Button
                  icon="pi pi-search"
                  v-tooltip.bottom="'Search'"
                  @click="search(1)"
              /></span>
              <!-- <Button
                  label="New"
                  icon="pi pi-plus"
                  class="p-button-success mr-2"
                  @click="openNew"
                /> -->
              <!-- <Button
                  label="Delete"
                  icon="pi pi-trash"
                  class="p-button-danger"
                  @click="confirmDeleteSelected"
                  :disabled="!selectedProducts || !selectedProducts.length"
                /> -->
              <!-- &nbsp;
                <Button
                  icon="pi pi-sync"
                  class="p-button-info mr-2"
                  @click="get_list"
                /> -->
            </div>
          </template>

          <template v-slot:end>
            <!-- <FileUpload
                mode="basic"
                accept="image/*"
                :maxFileSize="1000000"
                label="Import"
                chooseLabel="Import"
                class="mr-2 inline-block"
              /> -->
            <!-- <Button
              icon="pi pi-plus"
              v-tooltip.bottom="'Add'"
              @click="openNew"
            />&nbsp; -->
            <!-- <json-excel :data="product">
              <Button
               
                icon="pi pi-upload"
                v-tooltip.bottom="'export'"
               @click="exportCSV"
              />
              </json-excel> -->
          </template>
        </Toolbar>

        <DataTable
          :loading="loading"
          ref="dt"
          :lazy="true"
          :totalRecords="totalRecords"
          :paginator="true"
          :value="products"
          v-model:selection="selectedProducts"
          :dataKey="columns[0]"
          :rows="limit"
          :filters="filters"
          @page="onPage($event)"
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          :rowsPerPageOptions="[5, 10, 25, totalRecords]"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
          responsiveLayout="scroll"
          style="font-size: 12px"
          :rowHover="true"
          showGridlines
        >
          <template #empty>
            <b style="text-align: center">No records found.</b>
          </template>
          <template #header>
            <div
              class="flex flex-column md:flex-row md:justify-content-between md:align-items-center"
            >
              <h5 class="m-0"><b> Service Master</b></h5>
              <!-- Total Records:{{totalRecords}} -->

              <Button
                icon="pi pi-refresh"
                @click="search(2)"
                v-tooltip.bottom="'Refresh'"
              />
            </div>
            <div style="text-align: right; font-weight: bold">
              <span>Total Menus:</span>{{ totalRecords }}
            </div>
          </template>

          <Column
            header="Status"
            style="min-width: 8rem; text-align: center"
            :field="columns[5]"
          >
            <template #body="{ data }">
              <span v-if="data.status == 'Active' || data.status == 'active'"
                ><badge :value="data.status" severity="success"></badge
              ></span>
              <span
                v-else-if="
                  data.status == 'InActive' || data.status == 'In Active'
                "
                ><badge :value="data.status" severity="warning"></badge
              ></span>
              <span
                v-else-if="data.status == 'Delete' || data.status == 'Deleted'"
                ><badge :value="data.status" severity="danger"></badge
              ></span>
              <span v-else>-</span>
            </template>
          </Column>

          <Column header="Sr No" style="min-width: 5rem; text-align: center">
            <template #body="{ index }">
              <span v-if="page_no == 1">{{ +index + +1 }}</span>
              <span v-else>{{ +index + 1 + limit * (page_no - 1) }}</span>
            </template>
          </Column>

          <Column header="Tittle" :field="columns[1]" style="min-width: 5rem">
            <template #body="{ data }">
              {{ data.title }}
            </template>
          </Column>
          <Column
            header="Service Name"
            :field="columns[1]"
            style="min-width: 5rem"
          >
            <template #body="{ data }">
              {{ data.service_name }}
            </template>
          </Column>

          <Column
            header="Service Type"
            :field="columns[2]"
            style="min-width: 10rem"
          >
            <template #body="{ data }">
              {{ data.service_type_name }}
            </template>
          </Column>
          <Column
            header="Registratio No."
            :field="columns[2]"
            style="min-width: 5rem"
          >
            <template #body="{ data }">
              {{ data.registration_number }}
            </template>
          </Column>
          <Column header="Address" :field="columns[2]" style="min-width: 10rem">
            <template #body="{ data }">
              {{ data.address }}
            </template>
          </Column>
          <Column header="State" :field="columns[2]" style="min-width: 5rem">
            <template #body="{ data }">
              {{ data.state }}
            </template>
          </Column>
          <Column header="City" :field="columns[2]" style="min-width: 5rem">
            <template #body="{ data }">
              {{ data.city }}
            </template>
          </Column>
          <Column header="Pincode" :field="columns[2]" style="min-width: 5rem">
            <template #body="{ data }">
              {{ data.pincode }}
            </template>
          </Column>
          <Column header="Email" :field="columns[2]" style="min-width: 10rem">
            <template #body="{ data }">
              {{ data.email_id }}
            </template>
          </Column>
          <Column
            header="Contact Person"
            :field="columns[2]"
            style="min-width: 10rem"
          >
            <template #body="{ data }">
              {{ data.contact_person_name }}
            </template>
          </Column>
          <Column
            header="Contact Person Mob."
            :field="columns[2]"
            style="min-width: 5rem"
          >
            <template #body="{ data }">
              {{ data.contact_person }}
            </template>
          </Column>

          <Column header="Action" headerStyle="min-width:15rem;">
            <template #body="slotProps">
              <Button
                icon="pi pi-eye"
                v-tooltip.bottom="'View'"
                class="p-button-rounded p-button-success mr-2"
                @click="viewProduct(slotProps.data)"
              />
              <!-- <Button
                icon="pi pi-pencil"
                class="p-button-rounded p-button-help mr-2"
                v-tooltip.bottom="'Edit'"
                @click="editProduct(slotProps.data)"
              /> -->

              <Button
                icon="pi pi-trash"
                v-tooltip.bottom="'Delete'"
                class="p-button-rounded p-button-warning mt-2"
                @click="confirmDeleteProduct(slotProps.data)"
              />
            </template>
          </Column>
        </DataTable>

        <Dialog
          header="services"
          v-model:visible="productDialog"
          :breakpoints="{ '960px': '75vw' }"
          :style="{ width: '70vw' }"
          :modal="true"
        >
          
        </Dialog>

        <!-- 
-----------------------------------------------------------------------------------------------------------   -->
        <Dialog
          v-model:visible="deleteProductDialog"
          :style="{ width: '450px' }"
          header="Confirm"
          :modal="true"
        >
          <div class="flex align-items-center justify-content-center">
            <i
              class="pi pi-exclamation-triangle mr-3"
              style="font-size: 2rem"
            />
            <span v-if="product"
              >Are you sure you want to delete <b>{{ product.service_name }}</b
              >?</span
            >
          </div>
          <template #footer>
            <Button
              label="No"
              icon="pi pi-times"
              class="p-button-text"
              @click="deleteProductDialog = false"
            />
            <Button
              label="Yes"
              icon="pi pi-check"
              class="p-button-text"
              @click="deleteservice"
            />
          </template>
        </Dialog>

        <Dialog
          v-model:visible="deleteProductsDialog"
          :style="{ width: '450px' }"
          header="Confirm"
          :modal="true"
        >
          <div class="flex align-items-center justify-content-center">
            <i
              class="pi pi-exclamation-triangle mr-3"
              style="font-size: 2rem"
            />
            <span v-if="product"
              >Are you sure you want to delete the selected products?</span
            >
          </div>
          <template #footer>
            <Button
              label="No"
              icon="pi pi-times"
              class="p-button-text"
              @click="deleteProductsDialog = false"
            />
            <Button
              label="Yes"
              icon="pi pi-check"
              class="p-button-text"
              @click="deleteSelectedProducts"
            />
          </template>
        </Dialog>
      </div>
    </div>
  </div>
</template>
  
  <script>
import { FilterMatchMode } from "primevue/api";
import ProductService from "../service/ProductService";
import JsonExcel from "vue-json-excel";
import BreadcrumbService from "../service/BreadcrumbService";

//import FormNewsMaster from "@/components/FormNewsMaster";
//import * as Survey from "survey-vue";

// import axios from "axios";
import apis from "@/apis";
import axios from "axios";
import { log } from "util";

export default {
  data() {
    return {
      place_details: "",
      end_place_details: "",
      searchme: "",
      name: "",
      page_no: 1,
      isLoading: false,
      isLoadingModel: false,
      loading: false,
      fullPage: true,
      file_attachment: "",

      icon_dropdown: [],

      service_name: "",

      dropdownItems: [
        { name: "Active", value: "Active" },
        { name: "InActive", value: "InActive" },
        { name: "Deleted", value: "Deleted" },
      ],

      parent_dropdownItems: [],
      selectstatus: { name: "", value: "" },
      parent_selectstatus: { name: "", value: "" },
      pick_icon: { name: "", value: "" },

      products: null,
      productDialog: false,
      deleteProductDialog: false,
      deleteProductsDialog: false,
      lazyParams: {},
      product: {},
      selectedProducts: null,
      filters: {},
      offset: 1,

      // selectstatus2: { name: "Motivational", value: "Motivational" },
      limit: 10,
      columns: [],
      head: [
        "Data Usages",
        "Network Connectivity",
        "Students",
        "Teachers",
        "Student Registration",
        "News Master",
        "Government Panel",
        "Feedback Master",
        "User Queries",
        "Schemes Master",
        "Notice Master",
        "Subject Master",
        "Teacher Schedule Master",
        "Teacher Schedule DE Master",
        "Query Types Master",
        "Sub Query Types Master",
        "Admin Users",
        "Application Roles",
        "Departments",
        "Cast Master",
        "Year Master",
        "District Master",
        "Student Attendance",
        "Student Document",
        "Teachers",
        "Radical ids",
        "Subject Topics",
        "Query Comments",
        "Student Submit Answers",
        "Mock Tests",
        "Mock Test Papers",
        "Mock Test Results",
        "Video",
        "Syllabus",
        "Course",
      ],
      pageno: 1,
      submitted: false,
      icons: null,
      totalRecords: 0,
      id: "",
      statuses: [
        { label: "INSTOCK", value: "instock" },
        { label: "LOWSTOCK", value: "lowstock" },
        { label: "OUTOFSTOCK", value: "outofstock" },
      ],

      BreadcrumbService : null,
breadcrumbHome: {},
breadcrumbItems: [],

    };
  },
  productService: null,

  async created() {
    this.productService = new ProductService();
    this.initFilters();

    this.BreadcrumbService = new BreadcrumbService();
	let Breadcrum_data = this.BreadcrumbService.Service()
	this.breadcrumbHome=Breadcrum_data.home;
	this.breadcrumbItems=Breadcrum_data.items;
  },
  async mounted() {
   
    this.id = this.$route.params.id;

    this.lazyParams = {
      first: 0,
      rows: this.limit,
      sortField: null,
      sortOrder: null,
      filters: this.filters,
    };
    if (this.totalRecords == 0) {
      await this.get_count();
    }
    await this.get_list();

    //alert(this.id);
  },
  watch: {
    async $route() {
      this.products = [];
      this.columns = [];
      this.totalRecords = 0;
      this.id = this.$route.params.id;
      if (this.id) {
        await this.get_count();
        this.get_list();
      }
    },
  },

  methods: {
    async search(count) {
      count == 2 ? (this.service_name = "") : "";
      await this.get_list();
      await this.get_count();
    },
    async viewProduct(product) {
      // console.log(JSON.stringify(product));
      await localStorage.setItem('saveservicedata',JSON.stringify(product));
      this.$router.push({name:"serviceProfile"});
    },
    editProduct(product) {
      this.file_attachment = "";
      this.product = { ...product };
      this.productDialog = true;

      this.selectstatus.value = this.product.menu_status;
      this.selectstatus.name = this.product.menu_status;

      this.pick_icon.value = this.product.menu_icon;
      this.pick_icon.name = this.product.menu_icon;

      this.parent_selectstatus = { name: "", value: "" };
      if (this.product.parentmenu.length > 0) {
        this.parent_selectstatus.value = this.product.parentmenu[0]._id;
        this.parent_selectstatus.name =
          this.product.parentmenu[0].parent_menu_name;
      }
    },

    isNumber(evt) {
      const charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      }
    },

    async onPage(event) {
      this.lazyParams = event;
      this.page_no = event.page + 1;
      this.limit = event.rows;

      if (this.totalRecords > 0) {
        this.get_list();
      }
    },
    get_count: function () {
      var data = {
        count: true,
        service_name: this.service_name,
      };
      this.loading = true;
      var promise = apis.ServiceList(data);
      promise.then((response) => {
        this.loading = false;
        //   console.log(response);
        this.totalRecords = response.data.data;
        //alert(this.totalRecords);
      });

      // console.log(data);
    },
    get_list: function () {
      var data = {
        limit: this.limit,
        page_no: this.page_no,
        count: false,
        service_name: this.service_name,
      };
      this.loading = true;
      var promise = apis.ServiceList(data, this.id);
      promise.then((response) => {
        this.loading = false;
        console.log(response);
        this.products = response.data.data;
        console.log(this.products[0]);
        if (this.columns.length == 0) {
          if (this.products.length > 0) {
            this.columns = Object.keys(this.products[0]);
          }
        }

        this.parent_dropdownItems = [];
        for (let a = 0; a < response.data.data.length; a++) {
          this.parent_dropdownItems.push({
            name: response.data.data[a].service_name,
            value: response.data.data[a]._id,
          });
        }
      });

      console.log(data);
    },
    formatCurrency(value) {
      if (value)
        return value.toLocaleString("en-US", {
          style: "currency",
          currency: "USD",
        });
      return;
    },
    openNew() {
      this.product = {};
      this.submitted = false;
      this.productDialog = true;

      this.selectstatus = { name: "", value: "" };
      this.parent_selectstatus = { name: "", value: "" };
      this.pick_icon = { name: "", value: "" };
    },
    hideDialog() {
      this.productDialog = false;
      this.submitted = false;
    },
    async addrole() {
      this.submitted = true;

      if (!this.product.service_name) {
        this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please Enter Menu Name",
          life: 3000,
        });
        return false;
      }

      // if (!this.product.menu_url) {
      //   this.$toast.add({
      //     severity: "error",
      //     summary: "error",
      //     detail: "Please Enter Menu URL",
      //     life: 3000,
      //   });
      //   return false;
      // }

      //parent menu
      // if (!this.parent_selectstatus.value) {
      //   this.$toast.add({
      //     severity: "error",
      //     summary: "error",
      //     detail: "Select Menu Parent Menu",
      //     life: 3000,
      //   });
      //   return false;
      // }
      if (!this.pick_icon.value) {
        this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please Select Menu Icon",
          life: 3000,
        });
        return false;
      }

      if (!this.selectstatus.value) {
        this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please Select Status",
          life: 3000,
        });
        return false;
      }
      if (!this.product.menu_sequence) {
        this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please Select Menu Sequence",
          life: 3000,
        });
        return false;
      }

      //edit
      if (this.product._id) {
        var data = {
          _id: this.product._id,

          service_name: this.product.service_name,
          menu_url: this.product.menu_url,
          menu_parent: this.parent_selectstatus.value,
          menu_icon: "pi pi-fw pi-" + this.pick_icon.value,
          menu_status: this.selectstatus.value,
          menu_sequence: this.product.menu_sequence,
          description: this.product.description,
          updated_at: "",
          updated_by: "",
        };

        this.isLoadingModel = true;
        var promise = apis.editmenu(data);
        promise
          .then((responseapi) => {
            this.$swal(responseapi.data.message);
            this.isLoadingModel = false;
            this.productDialog = false;
            this.get_list();
            this.get_count();
          })
          .catch((error) => {
            //console.log(error);
            this.isLoadingModel = false;
            this.productDialog = false;

            this.$swal.fire(error.response.data);
            this.get_list();
            this.get_count();
          });
      }
      //add-----------------------------------------------------------------------------------------------------------------
      else {
        var data1 = {
          service_name: this.product.service_name,
          menu_url: this.product.menu_url,
          menu_parent: this.parent_selectstatus.value,
          menu_icon: "pi pi-fw pi-" + this.pick_icon.value,
          menu_status: this.selectstatus.value,
          menu_sequence: this.product.menu_sequence,
          description: this.product.description,
          created_at: "",

          created_by: localStorage.getItem("full_name"),
        };
        this.isLoadingModel = true;
        var promises = apis.addmenu(data1);
        promises
          .then((response) => {
            this.isLoadingModel = false;

            this.productDialog = false;
            this.$swal(response.data.message);
            this.get_list();
            this.get_count();
          })
          .catch((error) => {
            //console.log(error);
            this.isLoadingModel = false;
            this.productDialog = false;

            this.$swal.fire(error.response.data);
            this.get_list();
            this.get_count();
          });
      }
    },

    confirmDeleteProduct(product) {
      this.product = product;
      this.deleteProductDialog = true;
    },
    deleteProduct() {
      this.products = this.products.filter((val) => val.id !== this.product.id);
      this.deleteProductDialog = false;
      this.product = {};
      this.$toast.add({
        severity: "success",
        summary: "Successful",
        detail: "Product Deleted",
        life: 3000,
      });
    },

    deleteservice() {
      if (this.product._id) {
        var data = {
          _id: this.product._id,
          user_id: localStorage.getItem("id"),
        };
        this.isLoadingModel = true;
        var promise = apis.deleteservicedata(data);
        promise.then((responseapi) => {
          this.isLoadingModel = false;

          if (responseapi.data.status == true) {
            // this.hideDialog1();
            this.deleteProductDialog = false;
            this.$swal(responseapi.data.message);
            this.get_list();
            this.get_count();
          } else {
            this.$swal("error to Delete Role");
          }
        });
      }
    },
    findIndexById(id) {
      let index = -1;
      for (let i = 0; i < this.products.length; i++) {
        if (this.products[i].id === id) {
          index = i;
          break;
        }
      }
      return index;
    },
    createId() {
      let id = "";
      var chars =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      for (var i = 0; i < 5; i++) {
        id += chars.charAt(Math.floor(Math.random() * chars.length));
      }
      return id;
    },

    async exportCSV() {
      this.limit = this.totalRecords;
      this.get_list();
      await this.$refs.dt.exportCSV();
    },
    confirmDeleteSelected() {
      this.deleteProductsDialog = true;
    },
    deleteSelectedProducts() {
      this.products = this.products.filter(
        (val) => !this.selectedProducts.includes(val)
      );
      this.deleteProductsDialog = false;
      this.selectedProducts = null;
      this.$toast.add({
        severity: "success",
        summary: "Successful",
        detail: "Products Deleted",
        life: 3000,
      });
    },
    initFilters() {
      this.filters = {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      };
    },
  },
  components: { downloadExcel: JsonExcel },
};
</script>
  
  <style scoped lang="scss">
@import "../assets/demo/badges.scss";
@import "../assets/demo/documentation.scss";

.icons-list {
  i {
    color: var(--text-color-secondary);
  }
}
</style>
  